// src/components/EmployerLayout.jsx

import React from 'react';
import { Outlet } from 'react-router-dom';
import EmployerTopBar from './EmployerTopBar';

const EmployerLayout = () => {
    return (
        <div className="min-h-screen bg-gray-50">
            <EmployerTopBar />
            <div className="pt-16"> {/* Add padding to prevent content from going under the fixed top bar */}
                <Outlet /> {/* This will render the child routes, e.g., EmployerDashboard */}
            </div>
        </div>
    );
};

export default EmployerLayout;